import z from 'zod'
import { ERROR_DEFAULT } from 'features/common/core/errors'
import { Currency } from 'features/common/core/entitites'
import api from 'features/common/transport'

const totalTipsResponseSchema = z.object({
    tips_total: z.array(z.object({
        currency: z.literal('bgn').or(z.literal('ron')),
        sum: z.number()
    })).or(z.null())
})

const getTotalTips = async ({ organizationId, currency }: { organizationId: number, currency: Currency }) => {
    const res = await api.get(`organization/tips/total/${organizationId}`)

    const parseRes = totalTipsResponseSchema.safeParse(await res.json())
    if (parseRes.success) {
        const currentTipsTotal = parseRes.data.tips_total?.find(tt => tt.currency.toUpperCase() === currency)
        return currentTipsTotal?.sum || 0
    }

    throw new Error(ERROR_DEFAULT)
}
export default getTotalTips
